<template>
  <div class="license">
    <h1>营业执照</h1>
    <img src="https://static.kuaiduizuoye.com/product/kdzy/license.png" alt="" />
    <footer class="footer">
      <p class="net-num">网信算备：440112873835401230019号</p>
      <p class="net-num">AI功能由银河大模型提供支持</p>
    </footer>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  created() {
    document.body.style.backgroundColor = '#FAF9F7';
  }
};
</script>
<style lang="less" scoped>
.license {
  padding-bottom: 100px;

  h1 {
    font-size: 30px;
    text-align: center;
    margin: 60px 0 30px;
  }

  img {
    display: block;
    width: 680px;
    margin: 0 auto;
  }

  .footer {
    position: fixed;
    width: 100%;
    text-align: center;
    bottom: 40px;
    .net-num {
      font-size: 26px;
      margin-top: 4px;
      color: #9DA0A3;
    }
  }
}
</style>
